import { useEffect } from 'react';
import { recordSiteSessionIfNeeded } from '../services/siteTrafficService';

/** Records one site visit per browser session (any page). Renders nothing. */
export default function SiteVisitTracker() {
  useEffect(() => {
    // Traffic analytics must never interrupt page rendering when the API is unavailable.
    void recordSiteSessionIfNeeded().catch(() => null);
  }, []);

  return null;
}
